<template>
  <div>
    <SearchFacet
      v-model="selection.titles"
      kind="title"
      title="Titel"
      :items="data.titles"
      :loading="isLoading"
      style="margin-bottom: 0.75rem;"
    />
  </div>
</template>

<script>
import SearchFacet from "@/components/SearchFacet.vue";

import api from "@/api";
import utilsMixin from "@/mixins/utils.js";

import { debounce } from "@/utils/misc.js";

import { createValidator } from "@/utils/validation.js";
import { createMapper, createWatchers } from "@/utils/mapping.js";

const validator = createValidator("search-form");
const mapper = createMapper("search-form");

import config from "@/config.json";

export default {
  mixins: [utilsMixin],
  components: { SearchFacet },
  watch: {
    ...createWatchers("$route.query", "syncFromQuery", {
      ignore: ["page", "view"],
    }),
    selection: {
      handler: "syncWithQuery",
      deep: true,
    },
    "$route.query": {
      handler: "update",
      // NOTE: should NOT run before children's watchers
      immediate: false,
    },
  },
  data() {
    return {
      isLoading: false,
      data: {
        titles: [],
      },
      selection: {
        titles: [],
      },
      facetValues: [],
      rangeValues: [],
      filterFacets: [],
    };
  },
  computed: {
    canSubmit() {
      return !!this.query.term;
    },
    query() {
      const query = mapper.fromURL(this.$route.query);
      if (validator.isValid(query)) {
        return validator.clean(query);
      } else {
        return {};
      }
    },
    metaFields() {
      return config.meta;
    },
    rangeFields() {
      return config.range;
    },
  },
  methods: {
    update(query, prevQuery = {}) {
      let mustReload = false;
      let mustReset = false;
      this.filterFacets = [];
      this.rangeValues = [];
      for (var meta in this.metaFields) {
        var field = this.metaFields[meta];
        if (query[field] != prevQuery[field]) {
          mustReload = true;
          var obj = { value: query[field], field: field };
          if (query[field]) {
            this.filterFacets.push(obj);
          }
        }
      }
      for (var range in this.rangeFields) {
        var entry = this.rangeFields[range];
        if (query[entry.field]) {
          var obj = null;
          if (entry.type == "date") {
            if (query[entry.field][0]) {
              obj = {
                field: entry.field,
                from: query[entry.field][0] + "-01-01T01:00:00Z",
                to: query[entry.field][1] + "-01-01T01:00:00Z",
              };
            }
          } else {
            obj = {
              field: entry.field,
              from: query[entry.field][0],
              to: query[entry.field][1],
            };
          }
          if (obj) {
            this.rangeValues.push(obj);
          }
        }
      }

      if (mustReload) {
        this.load();
      }
    },

    load: debounce(async function() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      const { total, facets } = await api.fetchSearchFacets({
        ...this.query,
        filterFacets: this.filterFacets,
        facetArr: ["f_title"],
        range: this.rangeValues,
      });

      const { titles } = facets;
      this.data = { titles };

      this.isLoading = false;
    }, 50),
    async tryToLoad() {
      if (this.canSubmit) {
        await this.load();
      }
    },
    compareArray(array1, array2) {
      return (
        array1.length === array2.length &&
        array1.every((value, index) => value === array2[index])
      );
    },

    async syncFromQuery(newValue, oldValue) {
      if (!this.isDeepEqual(newValue, oldValue)) {
        const { titles = [] } = this.query;

        this.selection = { titles };

        await this.tryToLoad();
      }
    },
    async syncWithQuery() {
      const { titles } = this.selection;

      // change facet related params only
      const query = mapper.toURL(
        {
          ...validator.clean({
            ...mapper.fromURL(this.$route.query),
            titles,
          }),
          // ... but drop current page
        },
        { ignore: ["page"] }
      );
      query["p"] = 1;
      this.$router.push({
        query,
      });

      await this.tryToLoad();
    },
  },
};
</script>
